import { Dialog, Theme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_DIALOG_FIELDS_FLOATING, LIGHT_DIALOG_FIELDS_FLOATING } = COLORS;

const StyledDialog = withStyles((theme: Theme) => ({
  paper: {
    //Modal color of calendar
    backgroundColor: theme.palette.type === 'dark' ? DARK_DIALOG_FIELDS_FLOATING : LIGHT_DIALOG_FIELDS_FLOATING,
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '8px !important',
  },
}))(Dialog);

export default StyledDialog;
